var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, action } from 'mobx';
import { api } from 'helpers/Api';
import { Article } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.articles = [];
        this.loaded = false;
        this.set = function (articles) {
            _this.articles = articles.map(function (article) { return new Article(article); });
            _this.loaded = true;
            return _this.articles;
        };
        this.push = function (article) {
            _this.articles.push(new Article(article));
            return _this.articles;
        };
        this.replace = function (article) {
            _this.articles.splice(_this.articles.findIndex(function (f) { return f.id === article.id; }), 1, article);
            return _this.articles;
        };
        this.pull = function (article) {
            _this.articles.splice(_this.articles.findIndex(function (a) { return a.id === article.id; }), 1);
            return _this.articles;
        };
    }
    default_1.prototype.read = function (id) {
        if (id)
            return api.get("article/".concat(id)).then(function (article) { return new Article(article); });
        return api.get('article').then(this.set);
    };
    default_1.prototype.create = function (article) {
        return api.post('article', article).then(this.push);
    };
    default_1.prototype.update = function (id, article) {
        return api.put('article/' + id, article).then(this.replace);
    };
    default_1.prototype.disable = function (id, disabled) {
        return api.patch('article/' + id, { disabled: disabled }).then(this.pull);
    };
    __decorate([
        observable
    ], default_1.prototype, "articles", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    __decorate([
        action
    ], default_1.prototype, "pull", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Articles/Store.ts
// module id = 667
// module chunks = 0